export default __webpack_public_path__ + "static/media/cloud-star-bg-smm.2d78ed84.svg";